import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// 将push进行缓存
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    mode: 'history',
    redirect: '/home',
    // base: '/new/',

    // scrollBehavior(to, from, savedPosition) {
    //   let name = to.name;
    //   if (savedPosition) {
    //     return savedPosition
    //   } else {
    //     if (name == 'index') {
    //       localStorage.setItem("jykNavIndex", 0);
    //     } else if (name == 'mobileAd') {
    //       localStorage.setItem("jykNavIndex", 2);
    //     } else if (name == 'casepage') {
    //       localStorage.setItem("jykNavIndex", 3);
    //     } else if (name == 'about') {
    //       localStorage.setItem("jykNavIndex", 4);
    //     } else {
    //       localStorage.setItem("jykNavIndex", 1);
    //     }
    //     return { x: 0, y: 0 }
    //   }
    // },
    routes: [
        // 首页
        {
            path: '/',
            name: 'home',
            component: () => import('@/view/home'),
        },
        {
            path: '/page',
            name: 'page',
            component: () => import('@/view/page'),
        },
        {
            path: '/blank',
            name: 'blank',
            component: () => import('@/view/blank'),
        },
        {
            path: '/search',
            name: 'search',
            component: () => import('@/view/search'),
        },
        
    ]
})
/**
 * @param {to} 将要去的路由
 * @param {from} 出发的路由
 * @param {next} 执行下一步
 */
router.beforeEach((to, from, next) => {

    next()
    // if (to.meta.needLogin && !$store.state.isLogin) {
    //   next({
    //     path: '/login'
    //   })
    // } else {
    //   next()
    // }
    // 滚动到顶部
    // document.body.scrollIntoView()
    document.documentElement.scrollTop = 0;
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js